import { styled } from 'styled-components';
export const EmptyStateContent = styled.div `
  display: grid;
  justify-items: center;
  gap: 24px;
  width: 360px;
`;
export const EmptyStateIcon = styled.div `
  display: flex;
  justify-items: center;
  align-items: center;
  border-radius: 50%;
  padding: 22px;
  background-color: #f0f1f3;
`;
export const EmptyStateTitle = styled.h5 `
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #1b1e23;
  text-align: center;
`;
export const EmptyStateSubtitle = styled.p `
  font-size: 16px;
  line-height: 26px;
  color: #758195;
  text-align: center;
`;
export const EmptyStateTextContainer = styled.div `
  display: grid;
  justify-items: center;
  gap: 8px;
  width: 100%;
`;
